'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('service-requests-edit', {
      url: '/service-requests/edit',
      template: '<service-requests-edit></service-requests-edit>'
    });
}



// WEBPACK FOOTER //
// ./client/app/service-requests/edit/service-requests-edit.routes.js